<template>
    <div>
        <h2 class="mb-5 text-center">تم تسجيل طلبك</h2>
        <v-row justify="center" align="center" class="mt-5">
            <v-col cols="12" md="5" class="text-center">
                <div class="mb-10">
                    تم استلام طلبكم بنجاح، سيتم التواصل مع الطلبات المكتملة المعلومات والتي تحقق شروط البرنامج، المدة المتوقعة للانتظار شهرين
                    <br>
                    (بإمكانكم الاستفسار عن حالة الطلب بالاتصال على الرقم 2232378)
                </div>
                
                <div class="mb-8">
                    <div class="error--text font-weight-bold mb-2" style="font-size: 1.03rem;">
                        ملاحظات هامة:
                    </div>
                    <div class="error--text" style="line-height: 1.2;">
                        - سيتم طلب صورة شخصية وصورة هوية حال تمت دعوتكم للمقابلة
                        <br>
                        - يخضع المتقدمون لاختبار قبول تخصصي أثناء المقابلة المهنية
                    </div>
                </div>

            </v-col>
            <v-col cols="12" md="5" class="d-none d-md-flex align-center justify-center">
                <v-img src="@/assets/illustrations/training_programs/app_sent.svg" max-width="400"></v-img>
            </v-col>
        </v-row>
        <v-row class="align-center justify-center mt-5 mb-5">
            <v-col cols="auto" class="text-center">
                <v-btn color="accent" rounded dark @click="redirectToHome()">عودة للصفحة الرئيسية</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    methods: {
        redirectToHome() {
            this.$router.push('/');
        }
    }
}
</script>